import React, { useContext, useEffect, useState } from "react";
import url from "../setting.json";
import Axios from "../shared/api/axios";
import { LanguageContext } from "../shared/context/lan-context";
import axios from "axios";
import { useTranslation } from "react-i18next";
import jsPDF from "jspdf";
const Olympiad = () => {
  const { t } = useTranslation();
  const { language } = useContext(LanguageContext);

  const grade = [
    { id: 0, name: "12 synp" },
    { id: 1, name: "11 synp" },
    { id: 2, name: "10 synp" },
    { id: 3, name: "9 synp" },
  ];

  const languages = [
    { id: 0, name: "Türkmen" },
    { id: 1, name: "Русский" },
    { id: 2, name: "English" },
  ];

  // ------------------------------award-------------------------------------------
  const [olimpId, setOlimpId] = useState();
  const [taslamaId, setTaslamaId] = useState();
  const olimp = [
    { id: 0, name: t("School level") },
    { id: 1, name: t("District level") },
    { id: 2, name: t("Regional level") },
    { id: 3, name: t("National level") },
    { id: 4, name: t("International level") },
  ];
  const taslama = [
    { id: 0, name: t("School level") },
    { id: 1, name: t("District level") },
    { id: 2, name: t("Regional level") },
    { id: 3, name: t("National level") },
    { id: 4, name: t("International level") },
  ];

  // ------------------------------award-------------------------------------------
  const [welayat, setWelayat] = useState();
  const [openModel, setOpenModel] = useState(false);
  const [etrap, setEtrap] = useState();
  const [schoolName, setSchoolName] = useState();
  const [welayatId, setWelayatId] = useState();
  const [etrapId, setEtrapId] = useState();
  const [preferedSubject, setPreferedSubject] = useState();
  const [preferedSubjectID, setPreferedSubjectID] = useState();
  const [mailAdress, setMailAdress] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [pupils1, setPupils1] = useState();

  // Filter states
  const [searchQuery, setSearchQuery] = useState("");
  const [filterLanguages, setFilterLanguages] = useState("");
  const [filterGrade, setFilterGrade] = useState("");
  const [filterWelayat, setFilterWelayat] = useState("");
  const [filterEtrap, setFilterEtrap] = useState("");
  const [filterOlympiad, setFilterOlympiad] = useState("");
  const [filterTaslama, setFilterTaslama] = useState("");
  const [filterEtrapList, setFilterEtrapList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);

  const welayatlar = async () => {
    const apiUrl = `${url.DjangoUrl}olympiad/welayat/`;
    const resp = await Axios(apiUrl, "GET", language);
    setWelayat(resp.data);
  };
  const etraplar = async () => {
    if (welayatId) {
      const apiUrl = `${url.DjangoUrl}olympiad/etrap/?welayat=` + welayatId;
      const resp = await Axios(apiUrl, "GET", language);
      setEtrap(resp.data);
    }
  };
  const filterEtraplar = async () => {
    if (filterWelayat) {
      const apiUrl = `${url.DjangoUrl}olympiad/etrap/?welayat=` + filterWelayat;
      const resp = await Axios(apiUrl, "GET", language);
      setFilterEtrapList(resp.data);
    } else {
      setFilterEtrapList([]);
    }
  };
  const pupils = async () => {
    let apiUrl = `${url.DjangoUrl}olympiad/pupil/?`;
    const params = [];

    params.push(`page=${page}`);

    if (filterGrade) params.push(`grade=${filterGrade}`);
    if (filterLanguages) params.push(`language=${filterLanguages}`);
    if (filterWelayat) params.push(`etrap__welayat=${filterWelayat}`);
    if (filterEtrap) params.push(`etrap=${filterEtrap}`);
    if (filterOlympiad) params.push(`olympiad=${filterOlympiad}`);
    if (filterTaslama) params.push(`taslama=${filterTaslama}`);
    if (searchQuery) params.push(`search=${encodeURIComponent(searchQuery)}`);

    apiUrl += params.join("&");
    const resp = await Axios(apiUrl, "GET", language);
    setPupils1(resp.data.results || resp.data);
    setTotalCount(
      resp.data.count || resp.data.results?.length || resp.data.length || 0,
    );
    setNextPage(resp.data.next);
    setPreviousPage(resp.data.previous);
  };

  const preferedSubjects = async () => {
    const apiUrl = `${url.DjangoUrl}olympiad/preferred-subject/`;
    const resp = await Axios(apiUrl, "GET", language);
    setPreferedSubject(resp.data);
  };
  useEffect(() => {
    etraplar();
  }, [welayatId]);
  useEffect(() => {
    filterEtraplar();
  }, [filterWelayat]);
  useEffect(() => {
    preferedSubjects();
    welayatlar();
  }, []);
  const [is_open_reg, setIs_open_reg] = useState(false);
  // -------------------------------------------------------------------
  // const handleDownload = () => {
  //   const doc = new jsPDF();

  //   doc.text(
  //     20,
  //     50,
  //     `Salam,${idCode.name} ${idCode.surname} sizin ID codynyz: ${idCode.identificator} `,
  //   );
  //   doc.text(45, 20, `Turkmenistanyn Oguzhan adyndaky`);
  //   doc.text(45, 28, ` inzener-tehnalogiyalar universiteti`);
  //   doc.text(20, 60, `Olimpiyada baranynyzda id codynyzy yatdan cykarman`);
  //   const imgData = "/transpanrent-logo.png"; // Replace with the actual image data
  //   doc.addImage(imgData, "PNG", 20, 10, 20, 20);
  //   doc.save("Olimpiad registration code.pdf");
  // };
  // ==============================================================
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [fatherName, setFatherName] = useState();
  const [gradeID, setGradeID] = useState();

  const [idCode, setIdCode] = useState("");
  const [list, setList] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const afterSubmit = () => {
    setOpenModel(true);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    axios
      .post(url.DjangoUrl + "olympiad/pupil/", {
        name: name,
        surname: surname,
        father_name: fatherName,
        grade: parseInt(gradeID),
        welayat: parseInt(welayatId),
        etrap: parseInt(etrapId),
        school_name: schoolName,
        preferred_subject: parseInt(preferedSubjectID),
        email: mailAdress,
        phone: phoneNumber,
        language: parseInt(selectedLanguage),
        olympiad: parseInt(olimpId),
        taslama: parseInt(taslamaId),
      })
      .then(function (response) {
        if (response.status === 201) {
          setIdCode(response.data);
          setList(true);
        }
        if (response.status === 400) {
          setIdCode(response.data);
          setIdCode("Please check one more time");
        }
        setIsLoading(false);
      })
      .catch(function (error) {
        setIdCode("Please check one more time");
        console.error(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (idCode) {
      afterSubmit();
    }
  }, [idCode]);

  useEffect(() => {
    pupils();
  }, [
    filterGrade,
    filterLanguages,
    filterWelayat,
    filterEtrap,
    filterOlympiad,
    filterTaslama,
    idCode,
    searchQuery,
    page,
  ]);

  return (
    <div className="mb-5">
      <form className="flex transition-all" onSubmit={handleSubmit}>
        <div className="mt-16 w-9/12  mx-auto">
          <div
            className="my-5 flex items-center gap-1"
            onClick={(e) => setIs_open_reg(!is_open_reg)}
          >
            <label className="min-w-max">{t("Olympiad registration")}</label>
            <div className="h-[1px] w-full bg-gray-300"></div>
            <img
              className="w-5"
              src={
                is_open_reg
                  ? "./caret_up_and_down/caret-down.svg"
                  : "./caret_up_and_down/caret-up.svg"
              }
              alt=""
            />
          </div>
          {/* {is_open_reg && ( */}
          <div
            className={is_open_reg ? "flex flex-col   gap-2" : "h-0 w-0 hidden"}
          >
            <input
              name="name"
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              type="text"
              placeholder={`${t("name")} (${t("Example")}: Aman)`}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              required
            />
            <input
              name="surname"
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              type="text"
              placeholder={`${t("surname")} (${t("Example")}: Amanow)`}
              required
              onChange={(e) => {
                setSurname(e.target.value);
              }}
            />
            <input
              name="father's_name"
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              type="text"
              placeholder={`${t("father name")} (${t("Example")}: Amanowiç)`}
              onChange={(e) => {
                setFatherName(e.target.value);
              }}
            />
            <select
              name="class"
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setGradeID(e.target.value)}
              required
            >
              <option value="" selected disabled>
                {t("grade")}
              </option>
              {grade?.map((item, i) => (
                <option key={i} value={item.id}>
                  {t(item.name)}
                </option>
              ))}
            </select>

            <select
              name="welayat"
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setWelayatId(e.target.value)}
              required
            >
              <option value="" selected disabled>
                Welaýat
              </option>
              {welayat?.map((item, i) => (
                <option key={i} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
            {welayatId && (
              <select
                name="etrap"
                className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                onChange={(e) => setEtrapId(e.target.value)}
                required
              >
                <option value="" selected disabled>
                  Etraby
                </option>
                {welayatId &&
                  etrap?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            )}
            <input
              type="text"
              required
              value={schoolName}
              placeholder={`${t("name of school")} (${t("Example")}: №21)`}
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setSchoolName(e.target.value)}
            />
            <select
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setPreferedSubjectID(e.target.value)}
              required
            >
              <option value="" selected disabled>
                {t("Preferred subject")}
              </option>
              {preferedSubject?.map((item, i) => (
                <option key={i} value={item?.id}>
                  {item?.name}
                </option>
              ))}
            </select>

            {/* --------------------------diplom------------- */}

            <select
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setOlimpId(e.target.value)}
            >
              <option selected disabled>
                {t("Achievements in academic olympiads")}
              </option>
              {olimp?.map((item, i) => (
                <option key={i} value={item?.id}>
                  {item?.name}
                </option>
              ))}
            </select>
            <select
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setTaslamaId(e.target.value)}
            >
              <option selected disabled>
                {t(" Achievements in academic projects")}
              </option>
              {taslama?.map((item, i) => (
                <option key={i} value={item?.id}>
                  {item?.name}
                </option>
              ))}
            </select>
            {/* --------------------------diplom------------- */}
            <input
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              type="email"
              placeholder={`${t("Email")} (${t("Example")}: ahmet@gmail.com)`}
              onChange={(e) => setMailAdress(e.target.value)}
            />
            <input
              required
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              type="tel"
              pattern="\+993[0-9]{8}"
              title="Phone number must be in format: +993XXXXXXXX (e.g., +99365495443)"
              placeholder={`${t("Tel")} (${t("Example")}: +99365123456)`}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <select
              className="border-[1px] border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setSelectedLanguage(e.target.value)}
              required
            >
              <option value="" selected disabled>
                {t("Language")}
              </option>
              {languages?.map((item, i) => (
                <option key={i} value={item?.id}>
                  {item?.name}
                </option>
              ))}
            </select>

            {openModel && (
              <div className="flex justify-center">
                <div
                  onClick={(e) => {
                    setOpenModel(false);
                    setIs_open_reg(false);
                  }}
                  className="fixed top-0 left-0 w-full h-full bg-black/30"
                ></div>
                <div className="fixed m-auto  top-56 bg-white p-10 rounded-md flex flex-col gap-5">
                  <div className="w-full bg-green-100 border-[1px] border-green-600 rounded-md py-3 px-5 text-green-600 text-center ">
                    Bu sizin registrasiya nomeriniz, buny yatda saklamagynyzy
                    hayys edyan:{" "}
                    <span className="font-bold text-xl">
                      {idCode.identificator}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <button
              className="bg-blue-500 text-white p-2 rounded-md hover:bg-white hover:text-blue-500 border-[1px] border-blue-500 transition-all ease-in-out disabled:opacity-50 disabled:cursor-not-allowed"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center justify-center gap-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>{t("Sending")}...</span>
                </div>
              ) : (
                t("Send")
              )}
            </button>
          </div>
          {/* )} */}
        </div>
      </form>
      <div className=" w-9/12 mx-auto ">
        <div
          className="my-5 flex items-center gap-1"
          onClick={(e) => setList(!list)}
        >
          <label className="min-w-max">{t("Gatnashyjylar")}</label>
          <div className="h-[1px] w-full bg-gray-300"></div>
          <img
            className="w-5"
            src={
              list
                ? "./caret_up_and_down/caret-down.svg"
                : "./caret_up_and_down/caret-up.svg"
            }
            alt=""
          />
        </div>
        {list && (
          <>
            {/* Search and Filter Section */}
            <div className="mb-5 flex flex-col gap-3 bg-gray-50 p-4 rounded-md">
              <h3 className="font-semibold text-lg">{t("Search & Filter")}</h3>

              {/* Search Input */}
              <input
                type="text"
                placeholder={t("Search by name, surname or school...")}
                className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />

              {/* Filters */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {/* Grade Filter */}
                <select
                  className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                  value={filterGrade}
                  onChange={(e) => setFilterGrade(e.target.value)}
                >
                  <option value="">{t("All grades")}</option>
                  {grade?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {t(item.name)}
                    </option>
                  ))}
                </select>
                <select
                  className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                  value={filterLanguages}
                  onChange={(e) => setFilterLanguages(e.target.value)}
                >
                  <option value="">{t("Language")}</option>
                  {languages?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {t(item.name)}
                    </option>
                  ))}
                </select>

                {/* Welayat Filter */}
                <select
                  className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                  value={filterWelayat}
                  onChange={(e) => {
                    setFilterWelayat(e.target.value);
                    setFilterEtrap(""); // Reset etrap when welayat changes
                  }}
                >
                  <option value="">{t("All welayats")}</option>
                  {welayat?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>

                {/* Etrap Filter */}
                <select
                  className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                  value={filterEtrap}
                  onChange={(e) => setFilterEtrap(e.target.value)}
                  disabled={!filterWelayat}
                >
                  <option value="">{t("All etraps")}</option>
                  {filterEtrapList?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>

                {/* Olympiad Filter */}
                <select
                  className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                  value={filterOlympiad}
                  onChange={(e) => setFilterOlympiad(e.target.value)}
                >
                  <option value="">{t("All olympiad levels")}</option>
                  {olimp?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>

                {/* Taslama Filter */}
                <select
                  className="border-[1px] border-gray-300 rounded-md px-3 py-2"
                  value={filterTaslama}
                  onChange={(e) => setFilterTaslama(e.target.value)}
                >
                  <option value="">{t("All taslama levels")}</option>
                  {taslama?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>

                {/* Clear Filters Button */}
                <button
                  className="bg-gray-200 text-gray-700 p-2 rounded-md hover:bg-gray-300 transition-all"
                  onClick={() => {
                    setSearchQuery("");
                    setFilterGrade("");
                    setFilterLanguages("");
                    setFilterWelayat("");
                    setFilterEtrap("");
                    setFilterOlympiad("");
                    setFilterTaslama("");
                  }}
                >
                  {t("Clear Filters")}
                </button>
              </div>

              {/* Results Count */}
              <div className="text-sm text-gray-600">
                {t("Showing")} {pupils1?.length || 0}{" "}
                {(searchQuery ||
                  filterGrade ||
                  filterWelayat ||
                  filterEtrap ||
                  filterOlympiad ||
                  filterTaslama) &&
                totalCount > (pupils1?.length || 0)
                  ? `${t("of")} ${totalCount}`
                  : ""}{" "}
                {t("participants")}
              </div>
            </div>

            {/* Pagination Controls */}
            <div className="flex items-center justify-center mb-4 bg-gray-50 p-3 rounded-md">
              <div className="flex items-center gap-2">
                <button
                  className="px-3 py-1 border-[1px] border-gray-300 rounded-md text-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => setPage(page - 1)}
                  disabled={page <= 1}
                >
                  {t("Previous")}
                </button>
                <span className="text-sm text-gray-700">
                  {t("Page")} {page} - {pupils1?.length || 0} {t("items")} (
                  {t("Total")}: {totalCount})
                </span>
                <button
                  className="px-3 py-1 border-[1px] border-gray-300 rounded-md text-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => setPage(page + 1)}
                  disabled={!nextPage}
                >
                  {t("Next")}
                </button>
              </div>
            </div>

            <table className="w-full max-w-[1600px] mx-auto  p-2 border-collapse border bg-slate-100 border-slate-400 rounded-md">
              <tr>
                <th className="border border-slate-300 text-start p-3">
                  {t("№")}
                </th>
                <th className="border border-slate-300 text-start p-3">
                  {t("Name")}
                </th>
                <th className="border border-slate-300 text-start p-3">
                  {t("Region")}
                </th>
                <th className="border border-slate-300 text-end p-3">
                  {t("School")}
                </th>
              </tr>
              {pupils1?.map((item, i) => (
                <tr key={i}>
                  <td className="border border-slate-300 p-3 w-[100px]">
                    {totalCount - i - (page - 1) * 20}
                  </td>
                  <td className="border border-slate-300 w-[300px] p-3">
                    {item?.name} {item?.surname}
                  </td>
                  <td className="border border-slate-300 text-start p-3">
                    {item?.welayat?.name}
                  </td>
                  <td className="border border-slate-300 text-end p-3 w-[300px]">
                    {item?.school_name}
                  </td>
                </tr>
              ))}
            </table>
          </>
        )}
      </div>
    </div>
  );
};

// const DownloadButton = () => {
//   const handleDownload = async () => {
//     const elementToCapture = document.getElementById("pdf-content"); // The React component to capture
//     const canvas = await html2canvas(elementToCapture);
//     const imageData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF();
//     pdf.addImage(imageData, "PNG", 0, 0);

//     const fileName = "generated-pdf.pdf";
//     pdf.save(fileName);
//   };

//   return (
//     <div className="cursor-pointer" onClick={handleDownload}>
//       Download PDF
//     </div>
//   );
// };

// const PDFContent = ({ idCode }) => {
//   return (
//     <div
//       id="pdf-content"
//       className="p-5 border-[1px] border-gray-300 rounded-md"
//     >
//       <h1>
//         Salam {idCode?.name} {idCode?.surname} bu senin kodynyz yatdan cykarman
//       </h1>
//       <p>{idCode?.identificator}</p>
//     </div>
//   );
// };
export default Olympiad;
